import { render, staticRenderFns } from "./wordsList.vue?vue&type=template&id=0a78b80a&scoped=true&"
import script from "./wordsList.vue?vue&type=script&lang=js&"
export * from "./wordsList.vue?vue&type=script&lang=js&"
import style0 from "./wordsList.vue?vue&type=style&index=0&id=0a78b80a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a78b80a",
  null
  
)

export default component.exports